import React, {
    useEffect,
    useMemo,
    useState
} from 'react';

import {
    useDispatch,
    useSelector
} from 'react-redux';

import Swal from 'sweetalert2';


import HeaderUno
    from '../Metodos/Compartidos/HeaderUno';

import HeaderDos
    from '../Metodos/Compartidos/HeaderDos';


import useConfigAuth
    from '../../Hooks/useConfigAuth.js';


import {
    CuerpoCompleto
} from '../Css/StyledHeader.js';


import {
    solicitarHistoriasClinicasExportablesAction,
    prepararExportacionHistoriaClinicaAction,
    exportarHistoriasClinicasAction
} from '../../actions/exportacionHistoriaClinicaActions.js';


// css
import {

    HeaderExportacionFijo,

    Pagina,
    Contenedor,

    Encabezado,
    Subtitulo,
    AccionesEncabezado,
    BotonAyudaExportacion,
    BotonFantasma,

    GridPrincipal,

    Tarjeta,
    TituloTarjeta,
    SubtituloTarjeta,

    Toolbar,
    Buscador,
    IconoBuscar,
    InputBuscar,

    Segmentos,
    BotonSegmento,

    CabeceraLista,
    LabelSeleccionTodos,
    Check,
    ContadorSeleccion,

    ListaPacientes,
    FilaPaciente,
    BloquePaciente,
    NombrePaciente,
    MetaPaciente,
    BadgeEstado,

    SelectorPeriodo,
    SelectPeriodo,
    TextoPeriodoIndividual,

    ColumnaLateral,

    Presets,
    BotonPreset,
    TextoAyuda,

    ResumenGrid,
    Stat,
    StatValor,
    StatLabel,

    Nota,

    BotonPrincipal,
    MensajeProximamente,

    SeccionExportados,
    TablaContenedor,
    Tabla,
    TH,
    TD,
    BotonOrdenTabla,
    BotonReDescargar,

    EstadoVacio,
    EstadoVacioTitulo,
    EstadoVacioTexto,

    FondoModal,
    ModalExportacion,
    CabeceraModal,
    TituloModal,
    TextoModal,
    BotonCerrarModal,
    CuerpoModal,
    ResumenModal,
    FilaResumenModal,
    LabelModal,
    ValorModal,
    CampoModal,
    LabelCampoModal,
    InputModal,
    ErrorModal,
    ExitoModal,
    AccionesModal,
    BotonCancelarModal,
    BotonConfirmarModal

} from '../Css/StyledExportarHistoriasClinicas.js';


/*
====================================
MESES
====================================
*/

const MESES = [

    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre'

];


const MESES_CORTOS = [

    'ene',
    'feb',
    'mar',
    'abr',
    'may',
    'jun',
    'jul',
    'ago',
    'sep',
    'oct',
    'nov',
    'dic'

];


/*
====================================
PERÍODOS PREDEFINIDOS
====================================
*/

const PERIODOS_PREDEFINIDOS = [

    {
        id:
            'ACTUAL',

        nombre:
            'Mes actual'
    },

    {
        id:
            'ANTERIOR',

        nombre:
            'Mes anterior'
    },

    {
        id:
            'ULTIMOS_3',

        nombre:
            'Últimos 3 meses'
    },

    {
        id:
            'ULTIMOS_6',

        nombre:
            'Últimos 6 meses'
    },

    {
        id:
            'ULTIMOS_12',

        nombre:
            'Últimos 12 meses'
    },

    {
        id:
            'TODO',

        nombre:
            'Historial completo'
    }

];


/*
====================================
HELPERS
====================================
*/

const obtenerPeriodoActual = () => {

    const hoy =
        new Date();


    const anio =
        hoy.getFullYear();


    const mes =
        String(
            hoy.getMonth() + 1
        ).padStart(
            2,
            '0'
        );


    return `${anio}-${mes}`;

};


const moverMes = (
    periodo,
    cantidad
) => {

    const [
        anioInicial,
        mesInicial
    ] = periodo
        .split('-')
        .map(Number);


    const fecha =
        new Date(
            anioInicial,
            mesInicial - 1 + cantidad,
            1
        );


    return `${
        fecha.getFullYear()
    }-${
        String(
            fecha.getMonth() + 1
        ).padStart(
            2,
            '0'
        )
    }`;

};


const generarRangoMeses = (
    desde,
    hasta
) => {

    const resultado =
        [];


    if (
        !desde ||
        !hasta ||
        desde > hasta
    ) {

        return resultado;

    }


    let periodoActual =
        desde;


    while (
        periodoActual <=
        hasta
    ) {

        resultado.push(
            periodoActual
        );


        periodoActual =
            moverMes(
                periodoActual,
                1
            );

    }


    return resultado;

};


const formatearPeriodo = (
    periodo
) => {

    if (
        !periodo ||
        !/^\d{4}-\d{2}$/.test(
            periodo
        )
    ) {

        return periodo || '';

    }


    const [
        anio,
        mes
    ] = periodo
        .split('-');


    const nombreMes =
        MESES[
            Number(mes) - 1
        ] || '';


    return `${
        nombreMes
            .charAt(0)
            .toUpperCase()
    }${
        nombreMes.slice(1)
    } ${anio}`;

};


const formatearPeriodoCorto = (
    periodo
) => {

    if (
        !periodo ||
        !/^\d{4}-\d{2}$/.test(
            periodo
        )
    ) {

        return periodo || '';

    }


    const [
        anio,
        mes
    ] = periodo
        .split('-');


    return `${
        MESES_CORTOS[
            Number(mes) - 1
        ]
    } ${anio}`;

};


const formatearFecha = (
    fecha
) => {

    if (
        !fecha
    ) {

        return '—';

    }


    const fechaDate =
        new Date(
            fecha
        );


    if (
        Number.isNaN(
            fechaDate.getTime()
        )
    ) {

        return '—';

    }


    return fechaDate
        .toLocaleDateString(
            'es-AR',
            {
                day:
                    '2-digit',

                month:
                    '2-digit',

                year:
                    'numeric'
            }
        );

};


const normalizarTexto = (
    texto
) => {

    return String(
        texto || ''
    )
        .normalize(
            'NFD'
        )
        .replace(
            /[\u0300-\u036f]/g,
            ''
        )
        .toLowerCase()
        .trim();

};


const obtenerPeriodosPendientes = (
    paciente
) => {

    if (
        !Array.isArray(
            paciente?.periodos
        )
    ) {

        return [];

    }


    return paciente.periodos.filter(
        periodo =>
            periodo.estado_exportacion ===
            'PENDIENTE'
    );

};


const obtenerNombrePeriodo = (
    id
) => {

    const periodo =
        PERIODOS_PREDEFINIDOS.find(
            item =>
                item.id ===
                id
        );


    return periodo?.nombre ||
        'Mes actual';

};


const obtenerMesesSolicitados = (

    tipoPeriodo,

    paciente,

    periodoActual

) => {

    switch (
        tipoPeriodo
    ) {


        case 'ACTUAL':

            return [
                periodoActual
            ];


        case 'ANTERIOR':

            return [

                moverMes(
                    periodoActual,
                    -1
                )

            ];


        case 'ULTIMOS_3':

            return generarRangoMeses(

                moverMes(
                    periodoActual,
                    -3
                ),

                moverMes(
                    periodoActual,
                    -1
                )

            );


        case 'ULTIMOS_6':

            return generarRangoMeses(

                moverMes(
                    periodoActual,
                    -6
                ),

                moverMes(
                    periodoActual,
                    -1
                )

            );


        case 'ULTIMOS_12':

            return generarRangoMeses(

                moverMes(
                    periodoActual,
                    -12
                ),

                moverMes(
                    periodoActual,
                    -1
                )

            );


        case 'TODO':

            return obtenerPeriodosPendientes(
                paciente
            ).map(
                periodo =>
                    periodo.periodo
            );


        default:

            return [];

    }

};


const obtenerPeriodosAplicables = (

    paciente,

    tipoPeriodo,

    periodoActual

) => {

    const pendientes =
        obtenerPeriodosPendientes(
            paciente
        );


    if (
        tipoPeriodo ===
        'TODO'
    ) {

        return pendientes;

    }


    const mesesSolicitados =
        obtenerMesesSolicitados(

            tipoPeriodo,

            paciente,

            periodoActual

        );


    return pendientes.filter(
        periodo =>
            mesesSolicitados.includes(
                periodo.periodo
            )
    );

};


const obtenerRangoPaciente = (
    paciente
) => {

    const periodos =
        Array.isArray(
            paciente?.periodos
        )
            ?
            paciente.periodos
                .map(
                    periodo =>
                        periodo.periodo
                )
                .filter(Boolean)
                .sort()
            :
            [];


    if (
        periodos.length ===
        0
    ) {

        return 'Sin registros';

    }


    if (
        periodos.length ===
        1
    ) {

        return formatearPeriodoCorto(
            periodos[0]
        );

    }


    return `${
        formatearPeriodoCorto(
            periodos[0]
        )
    } – ${
        formatearPeriodoCorto(
            periodos[
                periodos.length - 1
            ]
        )
    }`;

};


/*
====================================
COMPONENTE
====================================
*/

const ExportarHistoriasClinicas = () => {


    /*
    ====================================
    REDUX / AUTH
    ====================================
    */

    const dispatch =
        useDispatch();


    const [
        config
    ] = useConfigAuth();


    const authToken =

        config?.headers?.Authorization ||

        config?.headers?.authorization ||

        null;


    const rol =
        useSelector(
            state =>
                state.usuario?.rol
        );


    const infoExportacion =
        useSelector(
            state =>
                state.informacion
                    ?.info_historias_clinicas_exportables
        ) || {

            scope:
                null,

            pacientes:
                []

        };


    const cargando =
        useSelector(
            state =>
                state.informacion
                    ?.historias_clinicas_exportables_cargando
        ) || false;


    const error =
        useSelector(
            state =>
                state.informacion
                    ?.historias_clinicas_exportables_error
        ) || null;


    const preparandoExportacion =
        useSelector(
            state =>
                state.informacion
                    ?.preparacion_exportacion_hc_cargando
        ) || false;


    const exportandoHistoriasClinicas =
        useSelector(
            state =>
                state.informacion
                    ?.exportacion_historias_clinicas_cargando
        ) || false;


    /*
    ====================================
    ESTADO LOCAL
    ====================================
    */

    const [
        busqueda,
        setBusqueda
    ] = useState(
        ''
    );


    const [
        filtroEstado,
        setFiltroEstado
    ] = useState(
        'TODOS'
    );

        /*
    ====================================
    ORDEN DE PERÍODOS EXPORTADOS
    ====================================

    Mantiene como orden inicial el que
    ya tenía la tabla:

    última exportación primero.

    El usuario puede ordenar por:

    - paciente;
    - período;
    - fecha de exportación.
    ====================================
    */

    const [
        ordenExportados,
        setOrdenExportados
    ] = useState({

        campo:
            'fecha',

        direccion:
            'desc'

    });

    const [
        seleccionados,
        setSeleccionados
    ] = useState(
        []
    );


    const [
        periodoPredeterminado,
        setPeriodoPredeterminado
    ] = useState(
        'ACTUAL'
    );


    const [
        periodosIndividuales,
        setPeriodosIndividuales
    ] = useState(
        {}
    );


    /*
    ====================================
    MODAL EXPORTACIÓN
    ====================================
    */

    const [
        modalAbierto,
        setModalAbierto
    ] = useState(
        false
    );


    const [
        passwordConfirmacion,
        setPasswordConfirmacion
    ] = useState(
        ''
    );


    const [
        errorModal,
        setErrorModal
    ] = useState(
        ''
    );


    const [
        preparacionValidada,
        setPreparacionValidada
    ] = useState(
        false
    );


    /*
    ====================================
    RE-DESCARGA
    ====================================

    Cuando tiene un valor, el modal deja
    de trabajar sobre la selección general
    y trabaja únicamente sobre ese período.
    ====================================
    */

    const [
        periodoReDescarga,
        setPeriodoReDescarga
    ] = useState(
        null
    );


    const periodoActual =
        useMemo(
            () =>
                obtenerPeriodoActual(),
            []
        );


    const puedeDescargar =
        String(
            rol
        ) ===
        '489431';


    /*
    ====================================
    AYUDA
    ====================================
    */

    const mostrarAyudaExportacion =
        () => {

            Swal.fire({

                title:
                    'Exportación de historias clínicas',

                html: `
                    <div
                        style="
                            text-align:left;
                            line-height:1.6;
                        "
                    >

                        <p>
                            En esta pantalla podés descargar
                            copias de las historias clínicas
                            registradas en YÖGEN.
                        </p>

                        <p>
                            <strong>Seleccioná uno o más pacientes</strong>
                            y elegí el período que querés exportar.
                            Se genera un PDF por paciente y por mes,
                            agrupados dentro de un único archivo ZIP.
                        </p>

                        <p>
                            Si un paciente no tiene historias clínicas
                            pendientes dentro del período seleccionado,
                            ese mes no genera un PDF.
                        </p>

                        <p>
                            Podés exportar el
                            <strong>mes actual</strong>.
                            El documento incluirá únicamente las historias
                            registradas hasta ese momento.
                            Si después se agrega o modifica una historia
                            clínica, ese mes volverá a aparecer como pendiente.
                        </p>

                        <p>
                            Los pacientes archivados también pueden incluirse,
                            ya que sus historias clínicas forman parte del
                            registro profesional.
                        </p>

                        <p>
                            En <strong>Períodos ya exportados</strong>
                            podés consultar qué meses ya cuentan con una copia
                            actualizada y volver a descargarlos si perdiste
                            el archivo anterior.
                        </p>

                        <p>
                            Antes de cada descarga se solicitará tu contraseña.
                            Los archivos contienen información clínica
                            confidencial y deben conservarse de forma segura.
                        </p>

                    </div>
                `,

                icon:
                    'info',

                confirmButtonText:
                    'Entendido',

                confirmButtonColor:
                    '#655EE8'

            });

        };


    /*
    ====================================
    SOLICITAR DATOS
    ====================================
    */

    useEffect(
        () => {

            if (
                !authToken
            ) {

                return;

            }


            dispatch(
                solicitarHistoriasClinicasExportablesAction({

                    config,

                    payload: {}

                })
            );

        },

        [
            authToken,
            dispatch
        ]

    );


    /*
    ====================================
    PACIENTES
    ====================================
    */

    const pacientes =
        useMemo(
            () => {

                return Array.isArray(
                    infoExportacion?.pacientes
                )
                    ?
                    infoExportacion.pacientes
                    :
                    [];

            },
            [
                infoExportacion
            ]
        );


    const pacientesConPendientes =
        useMemo(
            () => {

                return pacientes

                    .filter(
                        paciente =>
                            obtenerPeriodosPendientes(
                                paciente
                            ).length >
                            0
                    )

                    .sort(
                        (
                            pacienteA,
                            pacienteB
                        ) => {

                            const textoA =
                                `${
                                    pacienteA.apellido || ''
                                } ${
                                    pacienteA.nombre || ''
                                }`;


                            const textoB =
                                `${
                                    pacienteB.apellido || ''
                                } ${
                                    pacienteB.nombre || ''
                                }`;


                            return textoA.localeCompare(
                                textoB,
                                'es'
                            );

                        }
                    );

            },
            [
                pacientes
            ]
        );


    const pacientesVisibles =
        useMemo(
            () => {

                const textoBusqueda =
                    normalizarTexto(
                        busqueda
                    );


                return pacientesConPendientes.filter(
                    paciente => {


                        if (

                            filtroEstado ===
                            'ACTIVOS' &&

                            paciente.archivado

                        ) {

                            return false;

                        }


                        if (

                            filtroEstado ===
                            'ARCHIVADOS' &&

                            !paciente.archivado

                        ) {

                            return false;

                        }


                        if (
                            !textoBusqueda
                        ) {

                            return true;

                        }


                        const nombreCompleto =
                            normalizarTexto(
                                `${
                                    paciente.nombre || ''
                                } ${
                                    paciente.apellido || ''
                                }`
                            );


                        return nombreCompleto.includes(
                            textoBusqueda
                        );

                    }
                );

            },
            [

                pacientesConPendientes,
                filtroEstado,
                busqueda

            ]
        );


    /*
    ====================================
    SELECCIÓN
    ====================================
    */

    const estaSeleccionado = (
        paciente
    ) => {

        return seleccionados.includes(
            String(
                paciente.paciente_id_interno
            )
        );

    };


    const cambiarSeleccionPaciente = (
        paciente
    ) => {

        const idPaciente =
            String(
                paciente.paciente_id_interno
            );


        setSeleccionados(
            seleccionActual => {

                if (
                    seleccionActual.includes(
                        idPaciente
                    )
                ) {

                    return seleccionActual.filter(
                        id =>
                            id !==
                            idPaciente
                    );

                }


                return [

                    ...seleccionActual,

                    idPaciente

                ];

            }
        );

    };


    const idsVisibles =
        pacientesVisibles.map(
            paciente =>
                String(
                    paciente.paciente_id_interno
                )
        );


    const todosVisiblesSeleccionados =

        idsVisibles.length >
        0 &&

        idsVisibles.every(
            id =>
                seleccionados.includes(
                    id
                )
        );


    const cambiarSeleccionTodosVisibles = () => {

        setSeleccionados(
            seleccionActual => {

                const nuevaSeleccion =
                    new Set(
                        seleccionActual
                    );


                if (
                    todosVisiblesSeleccionados
                ) {

                    idsVisibles.forEach(
                        id =>
                            nuevaSeleccion.delete(
                                id
                            )
                    );

                } else {

                    idsVisibles.forEach(
                        id =>
                            nuevaSeleccion.add(
                                id
                            )
                    );

                }


                return Array.from(
                    nuevaSeleccion
                );

            }
        );

    };


    /*
    ====================================
    PERÍODO INDIVIDUAL
    ====================================
    */

    const cambiarPeriodoPaciente = (

        paciente,

        valor

    ) => {

        const idPaciente =
            String(
                paciente.paciente_id_interno
            );


        setPeriodosIndividuales(
            estadoAnterior => {

                const nuevoEstado = {

                    ...estadoAnterior

                };


                if (
                    valor ===
                    'PREDETERMINADO'
                ) {

                    delete nuevoEstado[
                        idPaciente
                    ];

                } else {

                    nuevoEstado[
                        idPaciente
                    ] = valor;

                }


                return nuevoEstado;

            }
        );

    };


    /*
    ====================================
    PLAN DE EXPORTACIÓN
    ====================================
    */

    const planExportacion =
        useMemo(
            () => {

                return seleccionados

                    .map(
                        idPaciente => {

                            const paciente =
                                pacientesConPendientes.find(
                                    item =>
                                        String(
                                            item.paciente_id_interno
                                        ) ===
                                        String(
                                            idPaciente
                                        )
                                );


                            if (
                                !paciente
                            ) {

                                return null;

                            }


                            const tipoPeriodo =

                                periodosIndividuales[
                                    String(
                                        paciente.paciente_id_interno
                                    )
                                ] ||

                                periodoPredeterminado;


                            const periodos =
                                obtenerPeriodosAplicables(

                                    paciente,

                                    tipoPeriodo,

                                    periodoActual

                                );


                            const mesesSolicitados =
                                obtenerMesesSolicitados(

                                    tipoPeriodo,

                                    paciente,

                                    periodoActual

                                );


                            const omitidos =

                                tipoPeriodo ===
                                'TODO'
                                    ?
                                    0
                                    :
                                    Math.max(

                                        0,

                                        mesesSolicitados.length -
                                        periodos.length

                                    );


                            return {

                                paciente,

                                tipoPeriodo,

                                periodos,

                                omitidos

                            };

                        }
                    )

                    .filter(Boolean);

            },
            [

                seleccionados,
                pacientesConPendientes,
                periodosIndividuales,
                periodoPredeterminado,
                periodoActual

            ]
        );


    const cantidadPacientes =
        planExportacion.length;


    const cantidadPdf =
        planExportacion.reduce(
            (
                total,
                item
            ) => {

                return total +
                    item.periodos.length;

            },
            0
        );


    const cantidadOmitidos =
        planExportacion.reduce(
            (
                total,
                item
            ) => {

                return total +
                    item.omitidos;

            },
            0
        );


    const mesesPlan =
        planExportacion

            .flatMap(
                item =>
                    item.periodos.map(
                        periodo =>
                            periodo.periodo
                    )
            )

            .sort();


    const rangoTotal =

        mesesPlan.length ===
        0
            ?
            '—'
            :
            mesesPlan[0] ===
            mesesPlan[
                mesesPlan.length - 1
            ]
                ?
                formatearPeriodoCorto(
                    mesesPlan[0]
                )
                :
                `${
                    formatearPeriodoCorto(
                        mesesPlan[0]
                    )
                } – ${
                    formatearPeriodoCorto(
                        mesesPlan[
                            mesesPlan.length - 1
                        ]
                    )
                }`;


    const incluyeMesActual =
        mesesPlan.includes(
            periodoActual
        );


    /*
    ====================================
    ITEMS EXPORTACIÓN NORMAL
    ====================================
    */

    const itemsExportacion =
        useMemo(
            () => {

                return planExportacion.flatMap(
                    item => {

                        return item.periodos.map(
                            periodo => ({

                                paciente_id_interno:
                                    Number(
                                        item.paciente
                                            .paciente_id_interno
                                    ),

                                periodo:
                                    periodo.periodo

                            })
                        );

                    }
                );

            },
            [
                planExportacion
            ]
        );


        /*
        ====================================
        YA EXPORTADOS
        ====================================
        */

        const periodosExportados =
            useMemo(
                () => {

                    const resultado =
                        [];


                    pacientes.forEach(
                        paciente => {

                            const periodosPaciente =
                                Array.isArray(
                                    paciente?.periodos
                                )
                                    ?
                                    paciente.periodos
                                    :
                                    [];


                            periodosPaciente.forEach(
                                periodo => {

                                    /*
                                    Esta tabla contiene únicamente
                                    períodos cuya última versión
                                    ya fue exportada.

                                    Si después cambia una HC,
                                    el backend lo devuelve como
                                    PENDIENTE y deja de aparecer
                                    en esta sección.
                                    */

                                    if (
                                        periodo.estado_exportacion !==
                                        'YA_EXPORTADO'
                                    ) {

                                        return;

                                    }


                                    resultado.push({

                                        paciente,

                                        periodo

                                    });

                                }
                            );

                        }
                    );


                    return resultado;

                },
                [
                    pacientes
                ]
            );


        /*
        ====================================
        FILTRAR Y ORDENAR EXPORTADOS
        ====================================

        El mismo buscador y los mismos filtros
        Todos / Activos / Archivados utilizados
        arriba afectan también esta tabla.
        ====================================
        */

        const periodosExportadosVisibles =
            useMemo(
                () => {

                    const textoBusqueda =
                        normalizarTexto(
                            busqueda
                        );


                    const resultado =
                        periodosExportados.filter(
                            item => {

                                const paciente =
                                    item.paciente;


                                /*
                                ====================================
                                ACTIVO / ARCHIVADO
                                ====================================
                                */

                                if (

                                    filtroEstado ===
                                    'ACTIVOS' &&

                                    paciente.archivado

                                ) {

                                    return false;

                                }


                                if (

                                    filtroEstado ===
                                    'ARCHIVADOS' &&

                                    !paciente.archivado

                                ) {

                                    return false;

                                }


                                /*
                                ====================================
                                BÚSQUEDA POR PACIENTE
                                ====================================
                                */

                                if (
                                    !textoBusqueda
                                ) {

                                    return true;

                                }


                                /*
                                Ponemos las dos combinaciones para que
                                funcionen búsquedas como:

                                Eduardo Loma
                                Loma Eduardo
                                Eduardo
                                Loma
                                */

                                const nombreBusqueda =
                                    normalizarTexto(
                                        `${
                                            paciente.nombre || ''
                                        } ${
                                            paciente.apellido || ''
                                        } ${
                                            paciente.apellido || ''
                                        } ${
                                            paciente.nombre || ''
                                        }`
                                    );


                                return nombreBusqueda.includes(
                                    textoBusqueda
                                );

                            }
                        );


                    /*
                    ====================================
                    ORDEN
                    ====================================
                    */

                    return [
                        ...resultado
                    ].sort(
                        (
                            itemA,
                            itemB
                        ) => {

                            let comparacion =
                                0;


                            switch (
                                ordenExportados.campo
                            ) {


                                /*
                                ====================================
                                PACIENTE
                                ====================================
                                */

                                case 'paciente': {

                                    const pacienteA =
                                        `${
                                            itemA.paciente
                                                .apellido || ''
                                        } ${
                                            itemA.paciente
                                                .nombre || ''
                                        }`;


                                    const pacienteB =
                                        `${
                                            itemB.paciente
                                                .apellido || ''
                                        } ${
                                            itemB.paciente
                                                .nombre || ''
                                        }`;


                                    comparacion =
                                        pacienteA.localeCompare(
                                            pacienteB,
                                            'es',
                                            {
                                                sensitivity:
                                                    'base'
                                            }
                                        );


                                    break;

                                }


                                /*
                                ====================================
                                PERÍODO
                                ====================================

                                YYYY-MM puede compararse directamente.
                                ====================================
                                */

                                case 'periodo': {

                                    const periodoA =
                                        itemA.periodo
                                            .periodo ||
                                        '';


                                    const periodoB =
                                        itemB.periodo
                                            .periodo ||
                                        '';


                                    comparacion =
                                        periodoA.localeCompare(
                                            periodoB
                                        );


                                    break;

                                }


                                /*
                                ====================================
                                FECHA DE EXPORTACIÓN
                                ====================================
                                */

                                case 'fecha':
                                default: {

                                    const fechaA =
                                        new Date(
                                            itemA.periodo
                                                .fecha_ultima_exportacion ||
                                            0
                                        ).getTime();


                                    const fechaB =
                                        new Date(
                                            itemB.periodo
                                                .fecha_ultima_exportacion ||
                                            0
                                        ).getTime();


                                    comparacion =
                                        fechaA -
                                        fechaB;


                                    break;

                                }

                            }


                            /*
                            ====================================
                            DESEMPATE
                            ====================================

                            Si dos valores son iguales,
                            mantenemos un orden predecible
                            por paciente y después período.
                            ====================================
                            */

                            if (
                                comparacion ===
                                0
                            ) {

                                const pacienteA =
                                    `${
                                        itemA.paciente
                                            .apellido || ''
                                    } ${
                                        itemA.paciente
                                            .nombre || ''
                                    }`;


                                const pacienteB =
                                    `${
                                        itemB.paciente
                                            .apellido || ''
                                    } ${
                                        itemB.paciente
                                            .nombre || ''
                                    }`;


                                comparacion =
                                    pacienteA.localeCompare(
                                        pacienteB,
                                        'es',
                                        {
                                            sensitivity:
                                                'base'
                                        }
                                    );

                            }


                            if (
                                comparacion ===
                                0
                            ) {

                                comparacion =
                                    String(
                                        itemA.periodo
                                            .periodo ||
                                        ''
                                    ).localeCompare(
                                        String(
                                            itemB.periodo
                                                .periodo ||
                                            ''
                                        )
                                    );

                            }


                            return (
                                ordenExportados.direccion ===
                                'asc'
                            )
                                ?
                                comparacion
                                :
                                comparacion * -1;

                        }
                    );

                },
                [

                    periodosExportados,

                    busqueda,

                    filtroEstado,

                    ordenExportados

                ]
            );


        /*
        ====================================
        CAMBIAR ORDEN
        ====================================
        */

        const cambiarOrdenExportados =
            campo => {

                setOrdenExportados(
                    ordenActual => {

                        /*
                        Si vuelve a tocar la misma
                        columna, invertimos el sentido.
                        */

                        if (
                            ordenActual.campo ===
                            campo
                        ) {

                            return {

                                campo,

                                direccion:
                                    ordenActual.direccion ===
                                    'asc'
                                        ?
                                        'desc'
                                        :
                                        'asc'

                            };

                        }


                        /*
                        Paciente empieza A → Z.

                        Período y fecha empiezan
                        por lo más reciente.
                        */

                        return {

                            campo,

                            direccion:
                                campo ===
                                'paciente'
                                    ?
                                    'asc'
                                    :
                                    'desc'

                        };

                    }
                );

            };


        /*
        ====================================
        INDICADOR VISUAL DE ORDEN
        ====================================
        */

        const obtenerIndicadorOrden =
            campo => {

                if (
                    ordenExportados.campo !==
                    campo
                ) {

                    return '↕';

                }


                return (
                    ordenExportados.direccion ===
                    'asc'
                )
                    ?
                    '↑'
                    :
                    '↓';

            };


    /*
    ====================================
    DATOS DEL MODAL
    ====================================
    */

    const esReDescarga =
        Boolean(
            periodoReDescarga
        );


    const itemsModal =
        useMemo(
            () => {

                if (
                    periodoReDescarga
                ) {

                    return [

                        {
                            paciente_id_interno:
                                Number(
                                    periodoReDescarga
                                        .paciente
                                        .paciente_id_interno
                                ),

                            periodo:
                                periodoReDescarga
                                    .periodo
                                    .periodo
                        }

                    ];

                }


                return itemsExportacion;

            },
            [
                periodoReDescarga,
                itemsExportacion
            ]
        );


    const cantidadPacientesModal =
        esReDescarga
            ?
            1
            :
            cantidadPacientes;


    const cantidadPdfModal =
        itemsModal.length;


    const rangoModal =
        esReDescarga
            ?
            formatearPeriodoCorto(
                periodoReDescarga
                    ?.periodo
                    ?.periodo
            )
            :
            rangoTotal;


    /*
    ====================================
    ABRIR MODAL EXPORTACIÓN NORMAL
    ====================================
    */

    const abrirModalExportacion = () => {

        if (
            !puedeDescargar ||
            cantidadPdf ===
            0
        ) {

            return;

        }


        setPeriodoReDescarga(
            null
        );


        setPasswordConfirmacion(
            ''
        );


        setErrorModal(
            ''
        );


        setPreparacionValidada(
            false
        );


        setModalAbierto(
            true
        );

    };


    /*
    ====================================
    ABRIR MODAL RE-DESCARGA
    ====================================
    */

    const abrirModalReDescarga = (
        item
    ) => {

        if (
            !puedeDescargar ||
            !item
        ) {

            return;

        }


        setPeriodoReDescarga(
            item
        );


        setPasswordConfirmacion(
            ''
        );


        setErrorModal(
            ''
        );


        setPreparacionValidada(
            false
        );


        setModalAbierto(
            true
        );

    };


    /*
    ====================================
    CERRAR MODAL
    ====================================
    */

    const cerrarModalExportacion = () => {

        if (
            preparandoExportacion ||
            exportandoHistoriasClinicas
        ) {

            return;

        }


        setModalAbierto(
            false
        );


        setPeriodoReDescarga(
            null
        );


        setPasswordConfirmacion(
            ''
        );


        setErrorModal(
            ''
        );


        setPreparacionValidada(
            false
        );

    };


    /*
    ====================================
    VALIDAR CONTRASEÑA / PLAN
    ====================================
    */

    const confirmarPreparacionExportacion =
        async () => {


            if (
                !passwordConfirmacion
                    .trim()
            ) {

                setErrorModal(
                    'Ingresá tu contraseña para continuar.'
                );

                return;

            }


            if (
                itemsModal.length ===
                0
            ) {

                setErrorModal(
                    'No hay historias clínicas para exportar.'
                );

                return;

            }


            setErrorModal(
                ''
            );


            setPreparacionValidada(
                false
            );


            const resultado =
                await dispatch(
                    prepararExportacionHistoriaClinicaAction({

                        config,

                        payload: {

                            password:
                                passwordConfirmacion,

                            items:
                                itemsModal

                        }

                    })
                );


            if (
                !resultado?.ok
            ) {

                setErrorModal(

                    resultado?.error?.msg ||

                    'No se pudo validar la exportación.'

                );

                return;

            }


            setPreparacionValidada(
                true
            );

        };


    /*
    ====================================
    DESCARGAR ZIP
    ====================================
    */

    const descargarZip =
        async () => {


            if (
                !preparacionValidada
            ) {

                return;

            }


            if (
                itemsModal.length ===
                0
            ) {

                setErrorModal(
                    'No hay historias clínicas para exportar.'
                );

                return;

            }


            const eraReDescarga =
                esReDescarga;


            setErrorModal(
                ''
            );


            const resultado =
                await dispatch(
                    exportarHistoriasClinicasAction({

                        config,

                        payload: {

                            password:
                                passwordConfirmacion,

                            items:
                                itemsModal

                        }

                    })
                );


            if (
                !resultado?.ok
            ) {

                setErrorModal(

                    resultado?.error?.msg ||

                    'No se pudo generar el archivo ZIP.'

                );

                return;

            }


            const blob =
                resultado.blob;


            if (
                !(blob instanceof Blob) ||
                blob.size ===
                0
            ) {

                setErrorModal(
                    'El archivo generado está vacío o no es válido.'
                );

                return;

            }


            /*
            ====================================
            DESCARGA NAVEGADOR
            ====================================
            */

            const urlTemporal =
                window.URL.createObjectURL(
                    blob
                );


            const enlace =
                document.createElement(
                    'a'
                );


            enlace.href =
                urlTemporal;


            enlace.download =

                resultado.nombreArchivo ||

                `historias_clinicas_${
                    new Date()
                        .toISOString()
                        .slice(
                            0,
                            10
                        )
                }.zip`;


            document.body.appendChild(
                enlace
            );


            enlace.click();


            enlace.remove();


            window.setTimeout(
                () => {

                    window.URL.revokeObjectURL(
                        urlTemporal
                    );

                },
                1500
            );


            /*
            ====================================
            LIMPIAR
            ====================================
            */

            if (
                !eraReDescarga
            ) {

                setSeleccionados(
                    []
                );


                setPeriodosIndividuales(
                    {}
                );

            }


            setModalAbierto(
                false
            );


            setPeriodoReDescarga(
                null
            );


            setPasswordConfirmacion(
                ''
            );


            setPreparacionValidada(
                false
            );


            /*
            ====================================
            REFRESCAR
            ====================================
            */

            await new Promise(
                resolve => {

                    window.setTimeout(
                        resolve,
                        700
                    );

                }
            );


            await dispatch(
                solicitarHistoriasClinicasExportablesAction({

                    config,

                    payload: {}

                })
            );

        };


    /*
    ====================================
    RENDER
    ====================================
    */

    return (

        <CuerpoCompleto>


            <HeaderExportacionFijo>

                <HeaderUno />


                <HeaderDos

                    link="/escritorio/calendario"

                    componente="Exportar historias clínicas"

                    paciente={
                        false
                    }

                />

            </HeaderExportacionFijo>


            <Pagina>

                <Contenedor>


                    {/*
                    ====================================
                    INTRODUCCIÓN
                    ====================================
                    */}

                    <Encabezado>

                        <Subtitulo>

                            Seleccioná los pacientes y los meses
                            que querés descargar.

                            Se genera un PDF por paciente y por mes,
                            todo dentro de un único archivo ZIP.

                        </Subtitulo>


                        <AccionesEncabezado>


                            <BotonAyudaExportacion

                                type="button"

                                title="¿Cómo funciona esta pantalla?"

                                aria-label="Ayuda sobre exportación de historias clínicas"

                                onClick={
                                    mostrarAyudaExportacion
                                }

                            >

                                ?

                            </BotonAyudaExportacion>


                            <BotonFantasma

                                type="button"

                                onClick={
                                    () => {

                                        document
                                            .getElementById(
                                                'periodos-exportados'
                                            )
                                            ?.scrollIntoView({

                                                behavior:
                                                    'smooth'

                                            });

                                    }
                                }

                            >

                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                >

                                    <circle
                                        cx="12"
                                        cy="12"
                                        r="9"
                                    />

                                    <path
                                        d="M12 7v5l3 2"
                                    />

                                </svg>

                                Períodos ya exportados

                            </BotonFantasma>


                        </AccionesEncabezado>

                    </Encabezado>


                    <GridPrincipal>


                        {/*
                        ====================================
                        PACIENTES
                        ====================================
                        */}

                        <Tarjeta>

                            <TituloTarjeta>
                                Seleccionar pacientes
                            </TituloTarjeta>


                            <SubtituloTarjeta>

                                Incluye pacientes activos y archivados.

                                Cada paciente puede utilizar el período
                                predeterminado o uno individual.

                            </SubtituloTarjeta>


                            <Toolbar>


                                <Buscador>

                                    <IconoBuscar
                                        viewBox="0 0 24 24"
                                    >

                                        <circle
                                            cx="11"
                                            cy="11"
                                            r="7"
                                        />

                                        <path
                                            d="M20 20l-4-4"
                                        />

                                    </IconoBuscar>


                                    <InputBuscar

                                        type="text"

                                        value={
                                            busqueda
                                        }

                                        onChange={
                                            event =>
                                                setBusqueda(
                                                    event.target.value
                                                )
                                        }

                                        placeholder="Buscar por nombre o apellido..."

                                    />

                                </Buscador>


                                <Segmentos>

                                    <BotonSegmento

                                        type="button"

                                        $activo={
                                            filtroEstado ===
                                            'TODOS'
                                        }

                                        onClick={
                                            () =>
                                                setFiltroEstado(
                                                    'TODOS'
                                                )
                                        }

                                    >
                                        Todos
                                    </BotonSegmento>


                                    <BotonSegmento

                                        type="button"

                                        $activo={
                                            filtroEstado ===
                                            'ACTIVOS'
                                        }

                                        onClick={
                                            () =>
                                                setFiltroEstado(
                                                    'ACTIVOS'
                                                )
                                        }

                                    >
                                        Activos
                                    </BotonSegmento>


                                    <BotonSegmento

                                        type="button"

                                        $activo={
                                            filtroEstado ===
                                            'ARCHIVADOS'
                                        }

                                        onClick={
                                            () =>
                                                setFiltroEstado(
                                                    'ARCHIVADOS'
                                                )
                                        }

                                    >
                                        Archivados
                                    </BotonSegmento>

                                </Segmentos>

                            </Toolbar>


                            <CabeceraLista>

                                <LabelSeleccionTodos>

                                    <Check

                                        type="checkbox"

                                        checked={
                                            todosVisiblesSeleccionados
                                        }

                                        onChange={
                                            cambiarSeleccionTodosVisibles
                                        }

                                    />

                                    Seleccionar todos los visibles

                                </LabelSeleccionTodos>


                                <ContadorSeleccion>

                                    {
                                        seleccionados.length
                                    } de {
                                        pacientesConPendientes.length
                                    }

                                </ContadorSeleccion>

                            </CabeceraLista>


                            {
                                cargando
                                    ? (

                                        <EstadoVacio>

                                            <EstadoVacioTitulo>
                                                Cargando historias clínicas...
                                            </EstadoVacioTitulo>

                                        </EstadoVacio>

                                    )
                                    :
                                    error
                                        ? (

                                            <EstadoVacio>

                                                <EstadoVacioTitulo>
                                                    No pudimos cargar las historias clínicas
                                                </EstadoVacioTitulo>

                                                <EstadoVacioTexto>

                                                    {
                                                        error?.msg ||
                                                        'Intentá nuevamente.'
                                                    }

                                                </EstadoVacioTexto>

                                            </EstadoVacio>

                                        )
                                        :
                                        pacientesVisibles.length ===
                                        0
                                            ? (

                                                <EstadoVacio>

                                                    <EstadoVacioTitulo>
                                                        No hay pacientes que coincidan con la búsqueda
                                                    </EstadoVacioTitulo>

                                                </EstadoVacio>

                                            )
                                            : (

                                                <ListaPacientes>

                                                    {
                                                        pacientesVisibles.map(
                                                            paciente => {

                                                                const idPaciente =
                                                                    String(
                                                                        paciente.paciente_id_interno
                                                                    );


                                                                const seleccionado =
                                                                    estaSeleccionado(
                                                                        paciente
                                                                    );


                                                                const periodoIndividual =
                                                                    periodosIndividuales[
                                                                        idPaciente
                                                                    ];


                                                                const cantidadPendientesPaciente =
                                                                    obtenerPeriodosPendientes(
                                                                        paciente
                                                                    ).length;


                                                                return (

                                                                    <FilaPaciente

                                                                        key={
                                                                            idPaciente
                                                                        }

                                                                        $seleccionado={
                                                                            seleccionado
                                                                        }

                                                                    >


                                                                        <Check

                                                                            type="checkbox"

                                                                            checked={
                                                                                seleccionado
                                                                            }

                                                                            onChange={
                                                                                () =>
                                                                                    cambiarSeleccionPaciente(
                                                                                        paciente
                                                                                    )
                                                                            }

                                                                        />


                                                                        <BloquePaciente>

                                                                            <NombrePaciente>

                                                                                {
                                                                                    paciente.apellido
                                                                                }, {
                                                                                    paciente.nombre
                                                                                }

                                                                            </NombrePaciente>


                                                                            <MetaPaciente>

                                                                                {
                                                                                    cantidadPendientesPaciente
                                                                                } {
                                                                                    cantidadPendientesPaciente ===
                                                                                    1
                                                                                        ?
                                                                                        'mes pendiente'
                                                                                        :
                                                                                        'meses pendientes'
                                                                                }

                                                                                {' · '}

                                                                                registros: {
                                                                                    obtenerRangoPaciente(
                                                                                        paciente
                                                                                    )
                                                                                }

                                                                            </MetaPaciente>

                                                                        </BloquePaciente>


                                                                        <BadgeEstado
                                                                            $archivado={
                                                                                paciente.archivado
                                                                            }
                                                                        >

                                                                            {
                                                                                paciente.archivado
                                                                                    ?
                                                                                    'Archivado'
                                                                                    :
                                                                                    'Activo'
                                                                            }

                                                                        </BadgeEstado>


                                                                        <SelectorPeriodo>

                                                                            <SelectPeriodo

                                                                                disabled={
                                                                                    !seleccionado
                                                                                }

                                                                                value={
                                                                                    periodoIndividual ||
                                                                                    'PREDETERMINADO'
                                                                                }

                                                                                onChange={
                                                                                    event =>
                                                                                        cambiarPeriodoPaciente(

                                                                                            paciente,

                                                                                            event.target.value

                                                                                        )
                                                                                }

                                                                            >

                                                                                <option
                                                                                    value="PREDETERMINADO"
                                                                                >

                                                                                    Predeterminado ({
                                                                                        obtenerNombrePeriodo(
                                                                                            periodoPredeterminado
                                                                                        )
                                                                                    })

                                                                                </option>


                                                                                {
                                                                                    PERIODOS_PREDEFINIDOS.map(
                                                                                        periodo => (

                                                                                            <option

                                                                                                key={
                                                                                                    periodo.id
                                                                                                }

                                                                                                value={
                                                                                                    periodo.id
                                                                                                }

                                                                                            >

                                                                                                {
                                                                                                    periodo.nombre
                                                                                                }

                                                                                            </option>

                                                                                        )
                                                                                    )
                                                                                }

                                                                            </SelectPeriodo>


                                                                            {
                                                                                seleccionado &&
                                                                                periodoIndividual
                                                                                    ? (

                                                                                        <TextoPeriodoIndividual>
                                                                                            Período individual
                                                                                        </TextoPeriodoIndividual>

                                                                                    )
                                                                                    :
                                                                                    null
                                                                            }

                                                                        </SelectorPeriodo>


                                                                    </FilaPaciente>

                                                                );

                                                            }
                                                        )
                                                    }

                                                </ListaPacientes>

                                            )
                            }

                        </Tarjeta>


                        {/*
                        ====================================
                        COLUMNA LATERAL
                        ====================================
                        */}

                        <ColumnaLateral>


                            <Tarjeta>

                                <TituloTarjeta>
                                    Período predeterminado
                                </TituloTarjeta>


                                <SubtituloTarjeta>

                                    Se aplica a los pacientes seleccionados
                                    que no tengan un período individual.

                                </SubtituloTarjeta>


                                <Presets>

                                    {
                                        PERIODOS_PREDEFINIDOS.map(
                                            periodo => (

                                                <BotonPreset

                                                    key={
                                                        periodo.id
                                                    }

                                                    type="button"

                                                    $activo={
                                                        periodoPredeterminado ===
                                                        periodo.id
                                                    }

                                                    onClick={
                                                        () =>
                                                            setPeriodoPredeterminado(
                                                                periodo.id
                                                            )
                                                    }

                                                >

                                                    {
                                                        periodo.nombre
                                                    }

                                                </BotonPreset>

                                            )
                                        )
                                    }

                                </Presets>


                                <TextoAyuda>

                                    {
                                        periodoPredeterminado ===
                                        'TODO'
                                            ?
                                            'Desde la primera hasta la última historia clínica pendiente de cada paciente.'
                                            :
                                            periodoPredeterminado ===
                                            'ACTUAL'
                                                ?
                                                formatearPeriodo(
                                                    periodoActual
                                                )
                                                :
                                                periodoPredeterminado ===
                                                'ANTERIOR'
                                                    ?
                                                    formatearPeriodo(
                                                        moverMes(
                                                            periodoActual,
                                                            -1
                                                        )
                                                    )
                                                    :
                                                    'Solo se incluyen los meses que tengan historias clínicas pendientes.'
                                    }

                                </TextoAyuda>

                            </Tarjeta>


                            <Tarjeta>

                                <TituloTarjeta>
                                    Resumen
                                </TituloTarjeta>


                                <ResumenGrid>

                                    <Stat>

                                        <StatValor>
                                            {
                                                cantidadPacientes
                                            }
                                        </StatValor>

                                        <StatLabel>
                                            pacientes
                                        </StatLabel>

                                    </Stat>


                                    <Stat>

                                        <StatValor>
                                            {
                                                cantidadPdf
                                            }
                                        </StatValor>

                                        <StatLabel>
                                            PDF a generar
                                        </StatLabel>

                                    </Stat>


                                    <Stat>

                                        <StatValor
                                            $naranja
                                        >
                                            {
                                                cantidadOmitidos
                                            }
                                        </StatValor>

                                        <StatLabel>
                                            meses sin historias pendientes
                                        </StatLabel>

                                    </Stat>


                                    <Stat>

                                        <StatValor
                                            $pequenio={
                                                rangoTotal !==
                                                '—'
                                            }
                                        >
                                            {
                                                rangoTotal
                                            }
                                        </StatValor>

                                        <StatLabel>
                                            rango total
                                        </StatLabel>

                                    </Stat>

                                </ResumenGrid>


                                {
                                    incluyeMesActual
                                        ? (

                                            <Nota
                                                $tipo="advertencia"
                                            >

                                                <svg
                                                    viewBox="0 0 24 24"
                                                >

                                                    <path
                                                        d="M12 9v4M12 17h.01"
                                                    />

                                                    <path
                                                        d="M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"
                                                    />

                                                </svg>

                                                <span>

                                                    Incluye <b>{
                                                        formatearPeriodo(
                                                            periodoActual
                                                        )
                                                    }</b>, que todavía está
                                                    en curso.

                                                    Si después cargás nuevas
                                                    historias clínicas, ese
                                                    período volverá a quedar
                                                    pendiente de exportación.

                                                </span>

                                            </Nota>

                                        )
                                        :
                                        null
                                }


                                <Nota
                                    $tipo="info"
                                >

                                    <svg
                                        viewBox="0 0 24 24"
                                    >

                                        <rect
                                            x="5"
                                            y="11"
                                            width="14"
                                            height="10"
                                            rx="2"
                                        />

                                        <path
                                            d="M8 11V7a4 4 0 0 1 8 0v4"
                                        />

                                    </svg>

                                    <span>

                                        El ZIP contiene datos clínicos
                                        confidenciales.

                                        Guardalo en un lugar seguro.

                                    </span>

                                </Nota>


                                {
                                    !puedeDescargar
                                        ? (

                                            <MensajeProximamente>
                                                Descarga disponible próximamente
                                            </MensajeProximamente>

                                        )
                                        :
                                        null
                                }


                                <BotonPrincipal

                                    type="button"

                                    disabled={

                                        !puedeDescargar ||

                                        cantidadPdf ===
                                        0

                                    }

                                    onClick={
                                        abrirModalExportacion
                                    }

                                >

                                    Descargar historias clínicas

                                </BotonPrincipal>

                            </Tarjeta>


                        </ColumnaLateral>


                    </GridPrincipal>


                    {/*
                    ====================================
                    PERÍODOS YA EXPORTADOS
                    ====================================
                    */}

                    <SeccionExportados
                        id="periodos-exportados"
                    >

                        <Tarjeta>

                            <TituloTarjeta>
                                Períodos ya exportados
                            </TituloTarjeta>


                            <SubtituloTarjeta>

                                Estos períodos ya cuentan con una
                                exportación actualizada.

                                Si una historia clínica se modifica
                                posteriormente, el período volverá a
                                aparecer como pendiente.

                                También podés volver a descargar una copia
                                sin modificar su estado.

                            </SubtituloTarjeta>


                            {
                                periodosExportados.length ===
                                0
                                    ? (

                                        <EstadoVacio>

                                            <EstadoVacioTitulo>
                                                Todavía no hay períodos exportados
                                            </EstadoVacioTitulo>

                                        </EstadoVacio>

                                    )
                                    :
                                    periodosExportadosVisibles.length ===
                                    0
                                        ? (

                                            <EstadoVacio>

                                                <EstadoVacioTitulo>
                                                    No hay períodos exportados que coincidan con los filtros
                                                </EstadoVacioTitulo>

                                                <EstadoVacioTexto>

                                                    Modificá la búsqueda o elegí
                                                    otro filtro de pacientes.

                                                </EstadoVacioTexto>

                                            </EstadoVacio>

                                        )
                                        : (

                                            <TablaContenedor>

                                                <Tabla>

                                                    <thead>

                                                        <tr>


                                                            {/*
                                                            ====================================
                                                            PACIENTE
                                                            ====================================
                                                            */}

                                                            <TH>

                                                                <BotonOrdenTabla

                                                                    type="button"

                                                                    $activo={
                                                                        ordenExportados.campo ===
                                                                        'paciente'
                                                                    }

                                                                    onClick={
                                                                        () =>
                                                                            cambiarOrdenExportados(
                                                                                'paciente'
                                                                            )
                                                                    }

                                                                    title="Ordenar por paciente"

                                                                >

                                                                    Paciente

                                                                    <span
                                                                        aria-hidden="true"
                                                                    >
                                                                        {
                                                                            obtenerIndicadorOrden(
                                                                                'paciente'
                                                                            )
                                                                        }
                                                                    </span>

                                                                </BotonOrdenTabla>

                                                            </TH>


                                                            {/*
                                                            ====================================
                                                            PERÍODO
                                                            ====================================
                                                            */}

                                                            <TH>

                                                                <BotonOrdenTabla

                                                                    type="button"

                                                                    $activo={
                                                                        ordenExportados.campo ===
                                                                        'periodo'
                                                                    }

                                                                    onClick={
                                                                        () =>
                                                                            cambiarOrdenExportados(
                                                                                'periodo'
                                                                            )
                                                                    }

                                                                    title="Ordenar por período"

                                                                >

                                                                    Período

                                                                    <span
                                                                        aria-hidden="true"
                                                                    >
                                                                        {
                                                                            obtenerIndicadorOrden(
                                                                                'periodo'
                                                                            )
                                                                        }
                                                                    </span>

                                                                </BotonOrdenTabla>

                                                            </TH>


                                                            <TH>
                                                                Registros
                                                            </TH>


                                                            {/*
                                                            ====================================
                                                            FECHA DE EXPORTACIÓN
                                                            ====================================
                                                            */}

                                                            <TH>

                                                                <BotonOrdenTabla

                                                                    type="button"

                                                                    $activo={
                                                                        ordenExportados.campo ===
                                                                        'fecha'
                                                                    }

                                                                    onClick={
                                                                        () =>
                                                                            cambiarOrdenExportados(
                                                                                'fecha'
                                                                            )
                                                                    }

                                                                    title="Ordenar por fecha de exportación"

                                                                >

                                                                    Fecha de exportación

                                                                    <span
                                                                        aria-hidden="true"
                                                                    >
                                                                        {
                                                                            obtenerIndicadorOrden(
                                                                                'fecha'
                                                                            )
                                                                        }
                                                                    </span>

                                                                </BotonOrdenTabla>

                                                            </TH>


                                                            <TH>
                                                                Acción
                                                            </TH>

                                                        </tr>

                                                    </thead>


                                                    <tbody>

                                                        {
                                                            periodosExportadosVisibles.map(
                                                                item => (

                                                                    <tr

                                                                        key={
                                                                            `${
                                                                                item.paciente
                                                                                    .paciente_id_interno
                                                                            }-${
                                                                                item.periodo
                                                                                    .periodo
                                                                            }`
                                                                        }

                                                                    >


                                                                        {/*
                                                                        ====================================
                                                                        PACIENTE
                                                                        ====================================
                                                                        */}

                                                                        <TD>

                                                                            <b>

                                                                                {
                                                                                    item.paciente
                                                                                        .apellido
                                                                                }, {
                                                                                    item.paciente
                                                                                        .nombre
                                                                                }

                                                                            </b>

                                                                            {
                                                                                item.paciente
                                                                                    .archivado
                                                                                    ?
                                                                                    ' · Archivado'
                                                                                    :
                                                                                    ''
                                                                            }

                                                                        </TD>


                                                                        {/*
                                                                        ====================================
                                                                        PERÍODO
                                                                        ====================================
                                                                        */}

                                                                        <TD>

                                                                            {
                                                                                formatearPeriodo(
                                                                                    item.periodo
                                                                                        .periodo
                                                                                )
                                                                            }

                                                                        </TD>


                                                                        {/*
                                                                        ====================================
                                                                        REGISTROS
                                                                        ====================================
                                                                        */}

                                                                        <TD>

                                                                            {
                                                                                item.periodo
                                                                                    .cantidad_entradas
                                                                            }

                                                                        </TD>


                                                                        {/*
                                                                        ====================================
                                                                        FECHA EXPORTACIÓN
                                                                        ====================================
                                                                        */}

                                                                        <TD>

                                                                            {
                                                                                formatearFecha(
                                                                                    item.periodo
                                                                                        .fecha_ultima_exportacion
                                                                                )
                                                                            }

                                                                        </TD>


                                                                        {/*
                                                                        ====================================
                                                                        ACCIÓN
                                                                        ====================================
                                                                        */}

                                                                        <TD>

                                                                            <BotonReDescargar

                                                                                type="button"

                                                                                disabled={

                                                                                    !puedeDescargar ||

                                                                                    preparandoExportacion ||

                                                                                    exportandoHistoriasClinicas

                                                                                }

                                                                                title={
                                                                                    puedeDescargar
                                                                                        ?
                                                                                        'Descargar nuevamente'
                                                                                        :
                                                                                        'Disponible próximamente'
                                                                                }

                                                                                onClick={
                                                                                    () =>
                                                                                        abrirModalReDescarga(
                                                                                            item
                                                                                        )
                                                                                }

                                                                            >

                                                                                Descargar nuevamente

                                                                            </BotonReDescargar>

                                                                        </TD>


                                                                    </tr>

                                                                )
                                                            )
                                                        }

                                                    </tbody>

                                                </Tabla>

                                            </TablaContenedor>

                                        )
                            }

                        </Tarjeta>

                    </SeccionExportados>


                </Contenedor>

            </Pagina>


            {/*
            ====================================
            MODAL
            ====================================
            */}

            {
                modalAbierto
                    ? (

                        <FondoModal

                            onMouseDown={
                                event => {

                                    if (
                                        event.target ===
                                        event.currentTarget
                                    ) {

                                        cerrarModalExportacion();

                                    }

                                }
                            }

                        >

                            <ModalExportacion>


                                <CabeceraModal>

                                    <div>

                                        <TituloModal>

                                            {
                                                esReDescarga
                                                    ?
                                                    'Descargar nuevamente'
                                                    :
                                                    'Confirmar exportación'
                                            }

                                        </TituloModal>


                                        <TextoModal>

                                            {
                                                esReDescarga
                                                    ?
                                                    `Vas a volver a descargar ${
                                                        formatearPeriodo(
                                                            periodoReDescarga
                                                                ?.periodo
                                                                ?.periodo
                                                        )
                                                    } de ${
                                                        periodoReDescarga
                                                            ?.paciente
                                                            ?.apellido
                                                    }, ${
                                                        periodoReDescarga
                                                            ?.paciente
                                                            ?.nombre
                                                    }.`
                                                    :
                                                    'Antes de descargar las historias clínicas necesitamos confirmar tu identidad.'
                                            }

                                        </TextoModal>

                                    </div>


                                    <BotonCerrarModal

                                        type="button"

                                        disabled={

                                            preparandoExportacion ||

                                            exportandoHistoriasClinicas

                                        }

                                        onClick={
                                            cerrarModalExportacion
                                        }

                                    >
                                        ×
                                    </BotonCerrarModal>

                                </CabeceraModal>


                                <CuerpoModal>


                                    <ResumenModal>


                                        <FilaResumenModal>

                                            <LabelModal>
                                                Pacientes
                                            </LabelModal>

                                            <ValorModal>
                                                {
                                                    cantidadPacientesModal
                                                }
                                            </ValorModal>

                                        </FilaResumenModal>


                                        <FilaResumenModal>

                                            <LabelModal>
                                                PDF a generar
                                            </LabelModal>

                                            <ValorModal>
                                                {
                                                    cantidadPdfModal
                                                }
                                            </ValorModal>

                                        </FilaResumenModal>


                                        <FilaResumenModal>

                                            <LabelModal>
                                                Período / rango
                                            </LabelModal>

                                            <ValorModal>
                                                {
                                                    rangoModal
                                                }
                                            </ValorModal>

                                        </FilaResumenModal>


                                    </ResumenModal>


                                    <CampoModal>

                                        <LabelCampoModal>
                                            Confirmá tu contraseña
                                        </LabelCampoModal>


                                        <InputModal

                                            type="password"

                                            autoComplete="new-password"

                                            value={
                                                passwordConfirmacion
                                            }

                                            disabled={

                                                preparandoExportacion ||

                                                exportandoHistoriasClinicas ||

                                                preparacionValidada

                                            }

                                            onChange={
                                                event => {

                                                    setPasswordConfirmacion(
                                                        event.target.value
                                                    );

                                                    setErrorModal(
                                                        ''
                                                    );

                                                    setPreparacionValidada(
                                                        false
                                                    );

                                                }
                                            }

                                            onKeyDown={
                                                event => {

                                                    if (

                                                        event.key ===
                                                        'Enter' &&

                                                        !preparandoExportacion &&

                                                        !exportandoHistoriasClinicas &&

                                                        !preparacionValidada

                                                    ) {

                                                        confirmarPreparacionExportacion();

                                                    }

                                                }
                                            }

                                            placeholder="Contraseña"

                                        />

                                    </CampoModal>


                                    <Nota
                                        $tipo="info"
                                    >

                                        <svg
                                            viewBox="0 0 24 24"
                                        >

                                            <rect
                                                x="5"
                                                y="11"
                                                width="14"
                                                height="10"
                                                rx="2"
                                            />

                                            <path
                                                d="M8 11V7a4 4 0 0 1 8 0v4"
                                            />

                                        </svg>

                                        <span>

                                            Vas a descargar información clínica
                                            confidencial.

                                            Guardá el archivo en un lugar seguro.

                                        </span>

                                    </Nota>


                                    {
                                        esReDescarga
                                            ? (

                                                <Nota
                                                    $tipo="advertencia"
                                                >

                                                    <span>

                                                        Esta acción genera una nueva
                                                        copia del período ya exportado.

                                                        No modifica ni elimina las
                                                        exportaciones anteriores.

                                                    </span>

                                                </Nota>

                                            )
                                            :
                                            null
                                    }


                                    {
                                        errorModal
                                            ? (

                                                <ErrorModal>

                                                    {
                                                        errorModal
                                                    }

                                                </ErrorModal>

                                            )
                                            :
                                            null
                                    }


                                    {
                                        preparacionValidada
                                            ? (

                                                <ExitoModal>

                                                    Contraseña y selección
                                                    verificadas correctamente.

                                                    Ya podés generar y descargar
                                                    el archivo ZIP.

                                                </ExitoModal>

                                            )
                                            :
                                            null
                                    }


                                    <AccionesModal>


                                        <BotonCancelarModal

                                            type="button"

                                            disabled={

                                                preparandoExportacion ||

                                                exportandoHistoriasClinicas

                                            }

                                            onClick={
                                                cerrarModalExportacion
                                            }

                                        >

                                            Cancelar

                                        </BotonCancelarModal>


                                        {
                                            !preparacionValidada
                                                ? (

                                                    <BotonConfirmarModal

                                                        type="button"

                                                        disabled={

                                                            preparandoExportacion ||

                                                            !passwordConfirmacion
                                                                .trim()

                                                        }

                                                        onClick={
                                                            confirmarPreparacionExportacion
                                                        }

                                                    >

                                                        {
                                                            preparandoExportacion
                                                                ?
                                                                'Verificando...'
                                                                :
                                                                'Confirmar contraseña'
                                                        }

                                                    </BotonConfirmarModal>

                                                )
                                                : (

                                                    <BotonConfirmarModal

                                                        type="button"

                                                        disabled={
                                                            exportandoHistoriasClinicas
                                                        }

                                                        onClick={
                                                            descargarZip
                                                        }

                                                    >

                                                        {
                                                            exportandoHistoriasClinicas
                                                                ?
                                                                'Generando ZIP...'
                                                                :
                                                                esReDescarga
                                                                    ?
                                                                    'Descargar nuevamente'
                                                                    :
                                                                    'Descargar ZIP'
                                                        }

                                                    </BotonConfirmarModal>

                                                )
                                        }


                                    </AccionesModal>


                                </CuerpoModal>


                            </ModalExportacion>

                        </FondoModal>

                    )
                    :
                    null
            }


        </CuerpoCompleto>

    );

};


export default ExportarHistoriasClinicas;